import { Routes } from '@angular/router';
import { InspectionPage } from './pages/inspection/inspection-page';
import { StartPage } from './pages/start-page/start-page';

export const routes: Routes = [
  { path: 'start/:linkId', component: StartPage },
  { path: 'inspection', component: InspectionPage },
  { path: '', redirectTo: 'inspection', pathMatch: 'full' },
  { path: '**', redirectTo: 'inspection' },
];
